import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppData } from '../../context/AppDataContext';
import { BRAND } from '../../theme/brandTokens';

const TeamMembersFallbackPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { currentStore } = useAppData();

  if (currentStore?.id) {
    return <Navigate to={`/management/stores/${currentStore.id}/team-members`} replace />;
  }

  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
        {t('teamMembers.fallback.message')}
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate('/management/stores')}
        sx={{ backgroundColor: BRAND.accent, color: BRAND.onAccent, '&:hover': { backgroundColor: BRAND.accentDark } }}
      >
        {t('teamMembers.fallback.goToStores')}
      </Button>
    </Box>
  );
};

export default TeamMembersFallbackPage;
